// extracted by mini-css-extract-plugin
export default {"wrapper":"PageLoader_wrapper__1czen","spinner":"PageLoader_spinner__zIvVJ","spin":"PageLoader_spin__cKK8K"};